import {
  IGroupedWorkPhases,
  IPermissionLevel,
  IWorkPhase
} from '@publishing-engine/domain/models';

/**
 * Builds the actual phase permissions object from the permissionsGroup form data
 *
 */
export const buildPhasePermissions = (
  groupedPhases: IGroupedWorkPhases = {},
  permissionsGroup: Partial<Record<IWorkPhase, IPermissionLevel>> = {}
) =>
  Object.keys(groupedPhases).reduce((acc, groupName) => {
    const phase = groupName as IWorkPhase;
    const permission = permissionsGroup[phase];

    if (permission) {
      acc[phase] = permission;
    }

    return acc;
  }, {} as Record<IWorkPhase, IPermissionLevel>);
